export default {"src":"/_next/static/media/calendar-success.49d62d62.svg","height":32,"width":28};